import { render, staticRenderFns } from "./onTheJob.vue?vue&type=template&id=713d8804&scoped=true"
import script from "./onTheJob.vue?vue&type=script&lang=js"
export * from "./onTheJob.vue?vue&type=script&lang=js"
import style0 from "./onTheJob.vue?vue&type=style&index=0&id=713d8804&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713d8804",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('713d8804')) {
      api.createRecord('713d8804', component.options)
    } else {
      api.reload('713d8804', component.options)
    }
    module.hot.accept("./onTheJob.vue?vue&type=template&id=713d8804&scoped=true", function () {
      api.rerender('713d8804', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/archives/onTheJob.vue"
export default component.exports